export default __webpack_public_path__ + "static/media/avatar-02.168bc508.svg";